var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { attrs: { "no-gutters": "" } },
    _vm._l(_vm.currentRules, function (rule, i) {
      return _c(
        "v-col",
        { key: `${rule}-${i}`, staticClass: "pa-0", attrs: { cols: "12" } },
        [
          _c(
            "div",
            { staticClass: "px-5 py-4" },
            [
              _c(
                "span",
                {
                  staticClass:
                    "py-2 d-block font-weight-medium body-1 grey-700--text",
                },
                [_vm._v(_vm._s(rule.childrens[0]?.title ?? ""))]
              ),
              _vm._l(
                rule.childrens.filter((item) => item.isMain ?? true),
                function (children) {
                  return _c(
                    "div",
                    { key: children.id },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "my-3",
                          attrs: { align: "center", "no-gutters": "" },
                        },
                        [
                          _c(
                            "v-col",
                            { staticClass: "pa-0 body-1 grey-500--text" },
                            [
                              children.label === "Correlativo"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("generals.Correlativo"))
                                    ),
                                  ])
                                : children.label === "RUT"
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.$t("generals.RUT"))),
                                  ])
                                : children.label === "FechaSUNAT"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("generals.FechaSUNAT"))
                                    ),
                                  ])
                                : _c("span", [_vm._v(_vm._s(children.label))]),
                            ]
                          ),
                          _c(
                            "v-col",
                            { staticClass: "pa-0", attrs: { cols: "1" } },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "justify-end mt-n5 mr-n1",
                                  attrs: { "no-gutters": "" },
                                },
                                [
                                  _c("v-switch", {
                                    attrs: {
                                      value: _vm.rulesAddedList.find(
                                        (item) => item.id === children.id
                                      ),
                                      color: "green-500",
                                      "hide-details": "",
                                      ripple: false,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.handleSwitch(
                                          $event,
                                          children
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.rulesAddedList.find(
                        (item) => item.id === children.id
                      ) && children.type !== "boolean"
                        ? _c(
                            "v-col",
                            { staticClass: "px-1 py-0", attrs: { cols: "12" } },
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { staticClass: "pb-5" },
                                    [
                                      _c("v-query-builder-rule", {
                                        attrs: { rule: children },
                                        on: {
                                          "update:rule": function ($event) {
                                            children = $event
                                          },
                                          remove: _vm.remove,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                }
              ),
            ],
            2
          ),
          i !== _vm.currentRules.length - 1 ? _c("v-divider", {}) : _vm._e(),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }